export enum SmartTagTemplate {
	'ASSET' = 'TagAsset',
	'DEFAULT' = 'TagDefault',
	'UPDATE' = 'TagUpdate',
	'VIEW' = 'TagView',
	// Custom Templates
	'INGROUND_POOL' = 'TagIngroundPool',
	'ROAD' = 'TagRoad',
	'CONVERTED_GARAGE' = 'TagConvertedGarage',
	// New Smart Tags
	'DEFICIENCY' = 'TagDeficiency',
	'POOL_TYPE' = 'TagPoolType',
	'COMPROMISE' = 'TagCompromise',
	'FEATURES' = 'TagFeatures',
	'MATERIALS' = 'TagMaterials',
	'WINDOWS' = 'TagWindows',
	'SURFACE' = 'TagSurface',
	'SPACE' = 'TagSpace',
	'UPDATE_TYPE' = 'TagUpdateType',
	'FENCE' = 'TagFence',
	// RENDER ENGINE
	'RENDER_FORM_RENDER' = 'TagFormRender'
}

export const SmartTagViewQualityOptions = [
	{
		key: 'UNOBSTRUCTED',
		label: 'Unobstructed View'
	},
	{
		key: 'PARTIAL',
		label: 'Partial View'
	},
	{
		key: 'OBSTRUCTED',
		label: 'Obstructed View'
	}
];

export const SmartTagViewAffectOptions = [
	{
		key: 'BENEFICIAL',
		label: 'Beneficial'
	},
	{
		key: 'ADVERSE',
		label: 'Adverse'
	}
];

export const SmartTagTimeframeOptions = [
	{
		key: 'LESS_THAN_ONE',
		label: 'Less than One Year'
	},
	{
		key: 'TWO_TO_FIVE',
		label: 'Two to Five Years'
	},
	{
		key: 'SIX_TO_TEN',
		label: 'Six to Ten Years'
	},
	{
		key: 'GREATER_THAN_TEN',
		label: 'Eleven to Fifteen Years'
	}
];

export const SmartTagRoadSubjectMaintainedOptions = [
	{
		key: 'PUBLIC',
		label: 'Public'
	},
	{
		key: 'PRIVATE',
		label: 'Private'
	},
	{
		key: 'UNKNOWN',
		label: 'Unknown'
	},
];
